import React, { useEffect } from "react";
import Banner from "../components/security/Banner";
import Architecture from "../components/security/Architecture";
import MoneyFlow from "../components/security/MoneyFlow";
import Transaction from "../components/security/Transaction";
import Faq from "../components/security/Faq";
import CTASection from "../components/security/CTASection";

function Security() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden">
      <Banner />
      <Architecture />
      <MoneyFlow />
      <Transaction />
      <Faq />
      <CTASection />
    </div>
  );
}

export default Security;
